import { z } from "zod";

export const createSkillSchema = z
	.object({
		name: z.string().min(1, { message: "Name is required" }).max(100),
		type: z.enum(["skill", "interest"]),
	})
	.strict();

export type CreateSkillPayload = z.infer<typeof createSkillSchema>;
